import React from 'react';
import { motion } from 'framer-motion';
import { ShopItem } from '../types';

interface ShoppingListProps {
  items: ShopItem[];
  cart: ShopItem[];
  onAddItem: (item: ShopItem) => void;
  onRemoveItem: (item: ShopItem) => void;
  remainingBudget: number;
}

export const ShoppingList: React.FC<ShoppingListProps> = ({
  items,
  cart,
  onAddItem,
  onRemoveItem,
  remainingBudget
}) => {
  const isItemInCart = (item: ShopItem) => 
    cart.some(cartItem => cartItem.id === item.id);

  const canAffordItem = (item: ShopItem) =>
    item.price <= remainingBudget;

  return (
    <div className="bg-white/20 rounded-2xl p-6">
      <h2 className="text-2xl font-bold mb-6">Shopping List</h2>
      
      <div className="space-y-4">
        {items.map((item) => {
          const inCart = isItemInCart(item);
          const canAfford = canAffordItem(item);
          
          return (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              className={`
                flex items-center justify-between p-4 rounded-xl
                ${inCart ? 'bg-white/30' : 'bg-white/10'}
                ${!canAfford && !inCart ? 'opacity-50' : ''}
              `}
            >
              <div>
                <div className="font-medium">{item.name}</div>
                <div className="text-sm opacity-90">
                  Price: ${item.price.toFixed(2)}
                  {item.gst && <span className="ml-2">(incl. GST)</span>}
                </div>
              </div>

              <button
                onClick={() => inCart ? onRemoveItem(item) : onAddItem(item)}
                disabled={!canAfford && !inCart}
                className={`
                  px-4 py-2 rounded-full font-medium
                  ${inCart 
                    ? 'bg-white/10 hover:bg-white/20' 
                    : 'bg-white text-[#4558C8] hover:opacity-90'}
                  transition-colors
                `}
              >
                {inCart ? 'Remove' : 'Add to Cart'}
              </button>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};